import { layout } from '@batiflow/ui';
import { __css, tokens } from '@fluentui/react-components';
import { useId, type ReactNode } from 'react';

const BORDER = tokens.colorNeutralStroke2;

const useStyles = __css({"section":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1noh358","Dbcxam":0,"rjzwhg":0,"Bblux5w":"f1ak2con","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1akouvx","De3pzq":"fxugw4r","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"f1o0qvyv","E5pizo":"f1whvlc6","gggo0z":"fi15kbk","Behc1zw":"f10zy6vx","B4m11q7":"f32hy0g","tzxy30":"fgmlvap","B834pou":"f1taw3pw","uk9mye":"f1p2dij1","rm1204":"fwyddsq","Bwezv66":"fwl1lcr","F1poyb":"foi3q75","mbw9mh":"f1a566p","ijz38e":"f1ftuoky","Ctt3hk":"f1crbv9w"},"header":{"mc9l5x":"f22iagw","Eh141a":"fni485r","Bt984gj":"f122n59","Brf1p80":"f1869bpl","i8kkvl":"f1xcgk68","Belr9w4":"f1wn3y0l"},"titles":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f778t4r","Bh6795r":"fqerorx","xawz":"fuk1rnt","Bgto7am":"fuzgk9b"},"title":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Be2twd7":"fod5ikn","Bg96gwp":"faaz57k","Bhrd7zp":"fl43uef"},"description":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","D305fb":"fo3dj2t","Be2twd7":"fkhj508","Bg96gwp":"f1i3iumi","sj55zd":"fkfq4zb"}});

export interface SettingsSectionProps {
  title: string;
  description?: string;
  /** Section-level actions, at the inline end of the title (wrapping below it on a phone). */
  actions?: ReactNode;
  children: ReactNode;
}

/** A titled block of an administration page: an h2 labelling the region, optional text and actions. */
export function SettingsSection({ title, description, actions, children }: SettingsSectionProps) {
  const styles = useStyles();
  const headingId = useId();
  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <div className={styles.header}>
        <div className={styles.titles}>
          <h2 id={headingId} className={styles.title}>
            {title}
          </h2>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
        {actions}
      </div>
      {children}
    </section>
  );
}


import "/opt/batiflow/app/apps/web/src/features/admin/components/settings-section.griffel.css";